import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DataService } from '../../services/data.service';
import { Observable, shareReplay } from 'rxjs';

@Component({
  selector: 'app-location-select-picker',
  templateUrl: './location-select-picker.component.html',
  styleUrls: ['./location-select-picker.component.scss', './location-select-picker.component.en.scss'],
})
export class LocationSelectPickerComponent implements OnInit, OnDestroy {
    static sharedObservable: Observable<any>;

    pageData: any;
    @Input({ required: true }) gpsX: string | undefined = '';
    @Input({ required: true }) gpsY: string | undefined = '';

    showMapsSelectModal: boolean = false;
    private escListener: any;
    private clickListener: any;

    constructor(private dataService: DataService, private eRef: ElementRef) {
        this.escListener = this.handleEscKey.bind(this);
        window.addEventListener('keydown', this.escListener);
    }

    ngOnInit(): void {
        this.getMapsBtnTextShared().subscribe(data => {
            this.pageData = data;
          });
    }

    ngOnDestroy(): void {
        window.removeEventListener('keydown', this.escListener);
    }

    private handleEscKey(event: KeyboardEvent): void {
        if (this.showMapsSelectModal && (event.key === 'Escape' || event.keyCode === 27)) {
            this.showMapsSelectModal = false;
        }
    }

    onOutsideClick(event: any) {
        if (this.showMapsSelectModal && !this.eRef.nativeElement.contains(event.target)) {
            this.closeMapsModal();
        }
    }

    getMapsBtnTextShared(): Observable<any> {
        if (!LocationSelectPickerComponent.sharedObservable) {
          let url = environment.apiUrl + '/Portal/Api/Widgets/GetLocationMapsListSettings';
          let request: any = {
              cultureCode: this.dataService.getCultureCode(),
          };
          LocationSelectPickerComponent.sharedObservable = this.dataService.getDataByToken(url, request)
            .pipe(
              shareReplay(1)
            );
        }
        return LocationSelectPickerComponent.sharedObservable;
      }

    openMapsModal() {
        if(!this.showMapsSelectModal) {
            this.showMapsSelectModal = true;
            setTimeout(() => {
                this.clickListener = this.onOutsideClick.bind(this);
                document.addEventListener('click', this.clickListener);
            }, 200);
        }
    }

    closeMapsModal() {
        if(this.showMapsSelectModal) {
            this.showMapsSelectModal = false;
            if(this.clickListener) {
                document.removeEventListener('click', this.clickListener);
                this.clickListener = null;
            }
        }
    }

    openInGoogleMaps() {
        window.open(
        `https://www.google.com/maps?q=${this.gpsX},${this.gpsY}`,
        '_blank'
        );
        this.closeMapsModal();
    }

    openInWaze() {
        window.open(
        `https://www.waze.com/ul?ll=${this.gpsX}%2C${this.gpsY}&navigate=yes`,
        '_blank'
        );
        this.closeMapsModal();
    }
}
